const BASE_URL = "/dimension";

export default [
  {
    path: `${BASE_URL}/dimension-list`,
    name: "dimensionList",
    component: () => import("@/modules/dimension/view/DimensionPage.vue"),
  },
  {
    path: `${BASE_URL}/coa-matrix`,
    name: "coaDimensionMatrix",
    component: () => import("@/modules/dimension/view/CoaDimensionMatrixPage.vue"),
  },
  {
    path: `${BASE_URL}/general-budget-entry`,
    name: "General Budget Entry",
    component: () => import("@/pages/dimension/generalBudgetEntry/Index.vue"),
  },
  {
    path: `${BASE_URL}/general-budget-journal`,
    name: "General Budget Journal",
    component: () => import("@/pages/dimension/generalBudgetJournal/Index.vue"),
  },
];
